import { computed } from 'vue'
import { createQuery } from '@/queries'
import { getAvailableStyles } from '@/features/my-style/api/my-style'
import type { AvailableStyle } from '@/types/my-style'
import type { AxiosResponse } from 'axios'

type AvailableStylesResponse = Awaited<
  ReturnType<typeof getAvailableStyles>
> extends AxiosResponse<infer T>
  ? T
  : never

export const useAvailableStylesQuery = () => {
  return createQuery<AvailableStylesResponse>({
    key: computed(() => ['available-styles']),
    fetcher: async () => {
      const response = await getAvailableStyles()
      return response.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes (менее часто меняются)
    enabled: computed(() => true)
  })
}

